export default __webpack_public_path__ + "static/media/bannersweb_RW_coche_moto_1000_330x330.7525b072.jpg";